var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG2Stars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    viewBox: "0 0 60 10.125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    display: "block"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "var(--fill-0, #FFB400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.323 0L6.58 3.866h4.066l-3.29 2.39 1.258 3.869-3.29-2.39-3.29 2.39L3.29 6.257 0 3.867h4.066L5.323 0zM17.66 0l1.258 3.866h4.066l-3.29 2.39 1.256 3.869-3.29-2.39-3.289 2.39 1.258-3.868-3.29-2.39h4.066L17.661 0zM30 0l1.257 3.866h4.066l-3.29 2.39 1.256 3.869L30 7.735l-3.29 2.39 1.258-3.868-3.29-2.39h4.066L30 0zM54.678 0l1.256 3.866H60l-3.29 2.39 1.258 3.869-3.29-2.39-3.29 2.39 1.257-3.868-3.29-2.39h4.066L54.678 0zM42.34 0l1.255 3.866h4.067l-3.29 2.39 1.257 3.869-3.29-2.39-3.29 2.39 1.256-3.868-3.29-2.39h4.068L42.34 0z"
  }))));
}
export default SvgG2Stars;